"use client";

import { useState } from "react";
import { Car as CarIcon } from "lucide-react";

const box =
  "relative h-14 w-14 shrink-0 overflow-hidden rounded-xl bg-gray-100 dark:bg-gray-800";

type Props = {
  src: string | null;
  alt: string;
  imgClassName?: string;
};

export default function PriceCompareThumb({ src, alt, imgClassName = "" }: Props) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div className={`${box} flex items-center justify-center text-gray-200 dark:text-gray-600`}>
        <CarIcon size={22} />
      </div>
    );
  }

  return (
    <div className={box}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={src}
        alt={alt}
        className={`h-full w-full object-cover ${imgClassName}`}
        loading="lazy"
        decoding="async"
        onError={() => setFailed(true)}
      />
    </div>
  );
}
